import { QueryClientProvider } from '@tanstack/react-query';
import { AuthContextProvider } from 'contexts/auth.context';
import { createBrowserHistory } from 'history';
import queryClient from 'lib/queryClient';
import React from 'react';
import { CookiesProvider } from 'react-cookie';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import App from './App/container';
import * as serviceWorker from './serviceWorker';
import store from './store';

import './index.scss';

const pathSegments = window.location.pathname.split('/');
const firstSegment = pathSegments[1];

// Only set basename if it's a feature branch (starts with "f-")
const isFeatureBranch = firstSegment?.startsWith('f-');
const basename = isFeatureBranch ? `/${firstSegment}` : '';
const history = createBrowserHistory({
  basename,
});

ReactDOM.render(
  <Provider store={store}>
    <CookiesProvider>
      <QueryClientProvider client={queryClient}>
        <Router history={history}>
          <AuthContextProvider>
            <App />
          </AuthContextProvider>
        </Router>
      </QueryClientProvider>
    </CookiesProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
